module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/15mill-active-ce249ee31d8159732632b6d59939b0c3.png";